module.exports = __webpack_public_path__ + "img/auto-eurotax.3cbcff6b.svg";